
import Vue from "vue";
import forEachBreakpoint from "../mixins/forEachBreakpoint";
import initials from "../mixins/initials";
import formatNumber from "../mixins/formatNumber";
export default Vue.extend({
  mixins: [forEachBreakpoint, initials, formatNumber],
  props: {
    product: {
      required: true,
      type: Object,

      default: () => {},
    },
    isLoaded: {
      required: true,
      type: Boolean,
      default: true,
    },
    isPublic: {
      required: true,
      type: Boolean,
      default: false,
    },
    publisherData: {
      required: true,
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      containerWidth: 280,
      categoryIcons: {
        "Apps Manager": "/../img/icons/Apps-Manager.png",
        "After Effects": "/../img/icons/After Effects-24.png",
        "Premiere Pro": "/../img/icons/Premiere-24.png",
        Photoshop: "/../img/icons/Photoshop-24.png",
        Illustrator: "/../img/icons/Illustrator-24.png",
        // Add more categories and icon links as needed
      },
    };
  },
  mounted() {
    this.updateContainerWidth();
    window.addEventListener("resize", this.updateContainerWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateContainerWidth);
  },
  // TODO: implement strategy sending to stats url based on user click
  methods: {
    toProductPage({ permalink }) {
      if (this.isPublic) {
        const productRoute = `/apps/${permalink}`;
        this.$router.push(productRoute);
      }
    },
    updateContainerWidth() {
      // Get the width of the container
      const container = document.querySelector(".zoom");
      if (container) {
        this.containerWidth = container.offsetWidth - 40;
      }
    },
    calculateDiscountedPrice(product) {
      if (!product.pricing.discount || product.pricing.discount <= 0) {
        // If there's no discount or the discount is 0 or negative, return the original price
        return product.pricing.basePrice;
      } else {
        // Calculate the discounted price
        const discountAmount =
          (product.pricing.discount / 100) *
          parseFloat(product.pricing.basePrice);
        const discountedPrice =
          parseFloat(product.pricing.basePrice) - discountAmount;
        return discountedPrice.toFixed(2); // Return the discounted price rounded to 2 decimal places
      }
    },
  },
  computed: {
    imageStyles() {
      return {
        display: "block",
        position: "relative",
        "margin-left": "auto",
        "margin-right": "auto",
        width: "100%",
        "max-width": "280px",
        "min-height": this.containerWidth + "px",
        "border-radius": "8px",
        cursor: this.isPublic && "pointer",
      };
    },
    promotionStyles() {
      return {
        background: "rgba(0, 0, 0, 0.8)",
        color: "white",
        position: "absolute",
        top: "10px",
        left: "0",
        "border-top-right-radius": "4px",
        "border-bottom-right-radius": "4px",
      };
    },
    imageURL() {
      return this.publisherData.imageURL;
    },
    isVerified() {
      return this.publisherData.isVerified;
    },
    fullName() {
      return this.publisherData.name;
    },
    name() {
      return this.publisherData.userName;
    },
    categoriesIcon() {
      return this.product.productCategory.map((category) => {
        if (category in this.categoryIcons) {
          return {
            icon: this.categoryIcons[category],
          };
        } else {
          return null; // Return null or a default icon link if category not found
        }
      });
    },
  },
});
